<div
  class="form-group"
  [ngClass]="{
    'icon-group-left': !!iconPath && iconPosition === 'left',
    'icon-group-right': !!iconPath && iconPosition === 'right'
  }">
  @if (isRequired) {
    @if (label) {
      <label [for]="name" Asterisk class="form-group-label text-dark {{ labelClass }}" [ngClass]="{ labelClass }">{{ label }}</label>
    }
  }
  @if (!isRequired) {
    @if (label) {
      <label [for]="name" class="form-group-label text-dark {{ labelClass }}">{{ label }}</label>
    }
  }
  <!-- ICON -->
  @if (iconPath && iconPosition === "left") {
    <img [src]="iconPath" [alt]="iconAltText" class="{{ iconClass }} input-icon" (click)="onIcon($event)" />
  }
  @if (!isTextArea) {
    <input
      [type]="type"
      class="form-control form-group-"
      [id]="name"
      [readOnly]="readOnly"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [min]="min"
      [minLength]="minLength"
      [max]="max"
      [maxlength]="maxLength"
      [(ngModel)]="model"
      (ngModelChange)="onModelChange($event)"
      (change)="onChange($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      (keyup)="onKeyUp($event)"
      (keydown)="onKeyDown($event)"
      (keydown.enter)="onEnter($event)" />
  }
  @if (isTextArea) {
    <textarea
      class="form-control form-group-"
      [id]="name"
      [rows]="textAreaRows"
      [readOnly]="readOnly"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [minLength]="minLength"
      [maxlength]="maxLength"
      [(ngModel)]="model"
      (ngModelChange)="onModelChange($event)"
      (change)="onChange($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      (keyup)="onKeyUp($event)"
      (keydown)="onKeyDown($event)"
      (keydown.enter)="onEnter($event)"></textarea>
  }
  @if (subText) {
    <small class="form-text text-muted fs-12 {{ subTextClass }}">{{ subText }}</small>
  }
  <!-- ICON -->
  @if (iconPath && iconPosition === "right") {
    <img [src]="iconPath" [alt]="iconAltText" class="{{ iconClass }} input-icon" (click)="onIcon($event)" />
  }
</div>
